const ITEMS = [
  "Evening & Weekend Appointments",
  "Same-Day Care by Phone",
  "In-Office Lab Draws by Appointment",
  "Military Family-Owned & Operated",
  "Now Accepting New Patients",
  "Prescott Valley · Prescott · Chino Valley · Dewey-Humboldt",
  "5-Star Patient Rating",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="values-marquee"
      aria-hidden="true"
      className="overflow-hidden bg-brand-red py-4"
    >
      <div className="flex w-max animate-marquee">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center whitespace-nowrap px-6 font-mono text-xs uppercase tracking-[0.28em] text-white"
          >
            {item}
            <span className="pl-12 text-white/50">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
